// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:afe86fc4-fa31-4be2-8d0c-159b24f7f3fb",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_fpG2CJmSM",
    "aws_user_pools_web_client_id": "5i96hll4vcl0894rpgsisr17g9",
    "aws_appsync_graphqlEndpoint": "https://kzo6abktxvbj3e4iibek5zx77a.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS"
};


export default awsmobile;



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/aws-exports.js